module.exports = __webpack_public_path__ + "img/paradise.a14bc0db.jpg";